export const LIST_SEPARATOR = '\n'
